/**
 * description:
 * author: 1580043700@qq.com
 * create_date: 2023/12/12-16:31
 */
import React, { useEffect, useRef, useState } from 'react'
import { SLowcodeList, STableActions } from 'shj-components'
import config from './config'
import { apiData2Table, enumFormat } from '@/utils/data.ts'
import { useFileUrlPrefix } from 'shj-utils'
import {
  asyncImportExportTaskRetry,
  asyncImportExportTaskUpdateById,
  deleteExportTask,
  downloadPage,
  getExportTaskStatus,
} from '@/services'
import {
  Button,
  Col,
  ConfigProvider,
  Flex,
  Form,
  Input,
  message,
  Progress,
  Row,
  Select,
  Space,
  Tag,
  theme,
} from 'antd'
import { fileDownload, fileLink } from '@/utils/download.ts'
import { useRequestTask } from '@/hooks/useRequestTask.ts'
import { useSetState } from 'ahooks'
import { getToken } from '@/common/utils.ts'

const DownloadsPage = (props: { tabRef?: any }) => {
  const listRef = useRef<any>()
  let { taskList: delList, run: runDel } = useRequestTask(deleteExportTask)
  let { taskList: restartList, run: runRestart } = useRequestTask(asyncImportExportTaskRetry)
  let { taskList: dowList, run: runDow } = useRequestTask(fileDownload)

  let [state, setState] = useSetState({ total: 0 })

  let [statusList, setStatusList]: any = useState([
    // { key: 1, label: '生成中' },
    // { key: 3, label: '生成成功' },
    // { key: -1, label: '生成失败' },
    // { key: 4, label: '下载成功' },
    // { key: 5, label: '下载失败' },
    // { key: 6, label: '下载中' },
  ])

  const [prefix] = useFileUrlPrefix()

  let themes = theme.useToken()
  let [form] = Form.useForm()

  useEffect(() => {
    getExportTaskStatus('com.shj.saas.plus.export.enums.ExportStateEnum').then((data: any) => {
      setStatusList(enumFormat(data, { label: 'label' }))
    })
  }, [])

  const reloadFn = () => {
    const {
      current: { reset },
    } = listRef
    reset()
  }
  if (props.tabRef) {
    props.tabRef.reload = reloadFn
  }
  // 获取下拉
  const getSelection = () => {
    return new Promise(resolve => {
      resolve({
        booleanOptions: statusList,
      })
    })
  }

  const getDownBtnText = (record): string => {
    switch (record.taskStatus) {
      case 'download_success':
        return '再次下载'
      case 'download_fail':
      case 'downloading':
        return '重新下载'
      default:
        return '点击下载'
    }
  }

  const getStatusTag = (key, record) => {
    let item = statusList.find(item => item.key === key)
    let style = {}
    switch (key) {
      case 'mark_fail':
      case 'download_fail':
        style = {
          color: 'rgb(227, 77, 89)',
          backgroundColor: 'rgb(248,203,206)',
        }
        break
      case 'mark_complete':
      case 'download_success':
      case 'mark_success':
        style = {
          color: 'rgb(0, 168, 112)',
          backgroundColor: 'rgb(201,245,230)',
        }
        break
      default:
        style = {
          color: 'rgb(68, 120, 247)',
          backgroundColor: 'rgba(174,196,250,0.33)',
        }
        break
    }
    if (key === 'downloading') {
      return <Progress percent={record.progress} />
    }
    return (
      <Tag style={style} bordered={false}>
        {item?.label || '生成中'}
      </Tag>
    )
  }

  const delExportTask = id => {
    runDel(id, id).then(() => {
      message.success('移除成功')
      reloadFn()
    })
  }
  const retry = id => {
    runRestart(id, id).then(() => {
      message.success('操作成功')
      reloadFn()
    })
  }
  const updateDataSource = (id: string, data: Record<string, any>) => {
    let list: Array<any> = listRef.current?.getDataSource?.() || []
    let index = list.findIndex(item => item.id === id)
    if (index !== -1) {
      let item = list[index]
      item = {
        ...item,
        ...data,
      }
      list[index] = item
      listRef.current?.updateDataSource?.([...list], state.total)
    }
  }

  const download = record => {
    updateDataSource(record.id, { taskStatus: '', progress: 0 })
    const baseUrl = record.tag.startsWith('http') ? void 0 : prefix
    const headers = baseUrl ? void 0 : { Authorization: false } // 使用 前缀时 headers 传空，download 函数自动获取 token

    runDow(record.id, record.tag, {
      baseURL: baseUrl,
      headers: headers,
      name: record.taskName,
      onDownloadProgress: res => {
        const { loaded = 0, total = 0 } = res || {}
        let progress = Number((loaded / total) * 100).toFixed()
        if (progress == '100') {
          updateDataSource(record.id, {
            taskStatus: 'download_success',
            progress: undefined,
            taskStatusName: '下载成功',
          })
          updateDataStatus(record, { taskStatus: 'download_success', result: '云端下载成功' })
          message.success('下载成功')
        } else {
          updateDataSource(record.id, { taskStatus: 'downloading', progress: progress })
        }
      },
    }).catch(() => {
      updateDataSource(record.id, {
        taskStatus: 'download_fail',
        progress: undefined,
        taskStatusName: '下载失败',
      })
      updateDataStatus(record, { taskStatus: 'download_fail', result: '云端下载失败' })
    })
  }

  const updateDataStatus = (record: any, status: Record<string, any>) => {
    let params = {
      id: record.id,
      ...status,
    }
    asyncImportExportTaskUpdateById({ data: params })
  }

  const fetchList = (values: any) => {
    return new Promise((resolve, reject) => {
      const { current, pageSize } = values
      let params = {
        pageId: current,
        pageSize: pageSize,
      }
      let fieldsValue = form.getFieldsValue()
      let taskStates = fieldsValue.taskStates
      let search = {
        ...fieldsValue,
      }
      if (taskStates === 'mark_ing') {
        search = {
          ...search,
          taskStates: ['mark_no', 'mark_ing'],
        }
      } else if (taskStates != null) {
        search = {
          ...search,
          taskStates: [taskStates],
        }
      }

      downloadPage({
        params,
        data: {
          ...{ orderBys: [{ columnName: 'created_time', asc: false }] },
          ...search,
        },
      })
        .then((data: any) => {
          const { total, records }: any = apiData2Table(data)
          setState({ total })
          resolve({
            total,
            records: records.map((value, index) => ({ ...value, indexOrder: index + 1 })),
          })
        })
        .catch(() => {
          reject({ success: false })
        })
    })
  }

  const onReset = () => {
    form.resetFields()
    listRef.current?.reloadAndSearch?.()
  }
  const onSearch = () => {
    listRef.current?.reloadAndSearch?.()
  }

  const extension = {
    request: {
      fetchList: fetchList,
      getSelection,
    },
    search: false,
    customRender: {
      statusRender: getStatusTag,
      actionTool(_: any, record: any) {
        return (
          <STableActions>
            {record?.taskStatus === 'mark_fail' && (
              <STableActions.SActionBtn
                loading={restartList.includes(record.id)}
                onClick={() => retry(record.id)}
              >
                重试
              </STableActions.SActionBtn>
            )}
            {record?.tag && (
              <STableActions.SActionBtn
                loading={dowList.includes(record.id)}
                onClick={() => download(record)}
              >
                {getDownBtnText(record)}
              </STableActions.SActionBtn>
            )}
            {record?.taskStatus !== 'mark_ing' && record?.taskStatus !== 'mark_no' && (
              <STableActions.SActionBtn
                danger
                loading={delList.includes(record.id)}
                onClick={() => delExportTask(record.id)}
              >
                移除
              </STableActions.SActionBtn>
            )}
          </STableActions>
        )
      },
    },
  }

  return (
    <div style={{ backgroundColor: '#fff', marginTop: 10 }}>
      <div style={{ padding: '15px' }}>
        <Form
          layout="inline"
          style={{ flex: 1 }}
          form={form}
          labelAlign="left"
          labelCol={{ style: { flexShrink: 0 } }}
          colon={false}
        >
          <Flex style={{ flex: 1 }} justify="space-between">
            <Row style={{ flex: 1 }}>
              <Col xs={12} sm={8} md={8} lg={6} xl={6} xxl={4} span={4}>
                <Form.Item label="文件名称" name="taskName">
                  <Input allowClear placeholder="请输入文件名称" />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} md={8} lg={6} xl={6} xxl={4} span={4}>
                <Form.Item label="状态" name="taskStates">
                  <Select allowClear placeholder="请选择状态">
                    {statusList
                      .filter(item => item.key !== 'downloading')
                      .map(item => (
                        <Select.Option key={item.key} value={item.key}>
                          {item.label}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Flex justify="flex-end">
              <Space>
                <Button onClick={onReset}>重置</Button>
                <Button type="primary" onClick={onSearch}>
                  查询
                </Button>
              </Space>
            </Flex>
          </Flex>
        </Form>
      </div>
      <SLowcodeList
        config={config}
        ref={listRef}
        {...extension}
        search={false}
        rowKey={'id'}
        scroll={{ y: 'calc(100vh - 210px)' }}
      />
    </div>
  )
}

export default DownloadsPage
